import React from 'react';

import { useGetRole } from '@vlabs/api/artemy/client';
import { LockOnIcon } from '@vlabs/icons';
import { DeleteRolesButton } from '@vlabs/monokit/features';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission, usePageAccess } from '@vlabs/permissions';
import { Breadcrumb, Breadcrumbs, Tag } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, useHistory } from 'react-router-dom';

import { useRoleDetailsPageTranslation } from '../i18n';
import { useRoleIdFromLocation } from '../useRoleIdFromLocation';

function RoleDetailsPageHeader(): React.JSX.Element {
  const { t } = useRoleDetailsPageTranslation();
  const history = useHistory();
  const roleId = useRoleIdFromLocation();
  const getRole = useGetRole(roleId);
  const pageCtx = usePageContext();
  const isSystem = getRole.data?.is_system ?? false;
  const canDeleteRole = useHasPermission('roles', 'delete');
  const canViewRoleList = usePageAccess('roles');

  const showDelete = canDeleteRole && !isSystem;

  return (
    <PageHeader
      actions={
        showDelete
          ? (
            <DeleteRolesButton
              onDeleteRoles={() => history.push(generatePath(routes.roles.list))}
              roleIds={[roleId]}
              size={pageCtx.buttonSize}
            />
          )
          : undefined
      }
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('role_list')}
            href={canViewRoleList ? routes.roles.list : undefined}
          />
          <Breadcrumb caption={getRole.data?.name ?? ''} />
        </Breadcrumbs>
)}
      tag={(
        isSystem
          ? (
            <Tag
              icon={<LockOnIcon />}
              shape="round"
              size={pageCtx.tagSize}
              value={t('is_system')}
            />
          )
          : undefined
      )}
      title={getRole.data?.name}
    />
  );
}

export { RoleDetailsPageHeader };
